import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Point extends OBase {
  update () {
    let valTree = this.getVector3Input('Point');
    let pOutput = this.getGenericObjectOutput('Point');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      outTree.addEmpty(valTree.paths[i]);
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        outTree.add(val, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Point.js